export default __webpack_public_path__ + "cf23fb9aedc68d35e06279fab7e06a7b.png";